import React from "react";
import { DetailField, DetailList } from "../../../../../../shared/frontend/components/DetailList";
import { useAuth } from "../../app/auth/useAuth";
import type { BankOrderPreview, BankOrderResult } from "../../app/api/bankOrders";
import { useI18n } from "../../app/i18n/useI18n";
import { formatMoney } from "../../app/units/format";
import { loadUnits } from "../../app/units/unitsStorage";
import { BankStatementAccessDialog, type BankAccessBody } from "./BankStatementAccessDialog";

/**
 * Einreichen eines Bankauftrags (Lastschriftlauf, Überweisungen) über den gemeinsamen Bankdialog:
 * PIN, TAN, App-Freigabe und Empfängerprüfung laufen dort. Zeigt vorher, was an welche Verbindung geht.
 */
export function BankOrderSubmitDialog({ preview, title, okText, submit, onClose, onBusy, onResult }: {
  preview: BankOrderPreview | null;
  title: string;
  okText: string;
  submit: (body: BankAccessBody, signal: AbortSignal) => Promise<BankOrderResult>;
  onClose: () => void;
  onBusy?: (busy: boolean) => void;
  onResult: (result: BankOrderResult) => void;
}) {
  const auth = useAuth();
  const { text } = useI18n();
  const units = React.useMemo(() => loadUnits(auth.info?.accountId), [auth.info?.accountId]);
  const summary = preview && <DetailList>
    <DetailField label={text("Online connection")}>{preview.connection.name ?? preview.connection.bankAccountName}</DetailField>
    <DetailField label={text("Count")}>{preview.transactionCount}</DetailField>
    <DetailField label={text("Total")}>{formatMoney(preview.totalAmount, units)}</DetailField>
  </DetailList>;
  return <BankStatementAccessDialog purpose="order" open={!!preview} connection={preview?.connection ?? null}
    order={{ title, okText, summary, submit }} onClose={onClose} onBusy={onBusy ?? (() => {})} onResult={onResult} />;
}
